/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  Card,
  Badge,
} from 'react-bootstrap';
import {
  FiSearch,
  FiMail,
  FiPhone,
  FiMessageCircle,
  FiExternalLink,
} from 'react-icons/fi';

const gradient =
  'linear-gradient(135deg, rgba(255,153,102,1) 0%, rgba(255,204,128,1) 30%, rgba(123,97,255,1) 100%)';

const SectionTitle: React.FC<{ title: string; subtitle?: string }> = ({
  title,
  subtitle,
}) => (
  <div className="text-center mb-4">
    <h2 className="fw-semibold" style={{ fontSize: 22, marginBottom: 6 }}>
      {title}
    </h2>
    {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
  </div>
);

SectionTitle.defaultProps = {
  subtitle: undefined,
};

const SupportPage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#fafafa' }}>
      {/* Topbar */}

      <section
        style={{
          background: gradient,
          padding: '64px 0 64px',
          height: '320px',
          color: '#1d1d1f',
        }}
      >
        <Container style={{ maxWidth: 980 }}>
          <h1
            className="text-center fw-bold"
            style={{ color: '#fff', fontSize: 40 }}
          >
            Como podemos ajudar?
          </h1>
          <Container className="mt-4" style={{ maxWidth: 720 }}>
            <InputGroup>
              <InputGroup.Text>
                <FiSearch />
              </InputGroup.Text>
              <Form.Control
                type="search"
                placeholder="Busque por 'denúncia offline', 'mídias', 'conta'…"
                aria-label="Buscar artigos de ajuda"
              />
              <Button variant="dark">Buscar</Button>
            </InputGroup>
          </Container>
        </Container>
      </section>

      {/* Quick categories */}
      <Container style={{ marginTop: -28, maxWidth: 980 }}>
        <Row className="g-3">
          <Col md={6}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div>
                  <Card.Title className="mb-1">
                    Essenciais do VivaVoz
                  </Card.Title>
                  <Card.Text className="text-muted mb-0">
                    Primeiros passos, conta e privacidade
                  </Card.Text>
                </div>
                <a href="#" className="text-decoration-none">
                  Ver tudo <FiExternalLink />
                </a>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex align-items-center justify-content-between">
                <div>
                  <Card.Title className="mb-1">Boas práticas</Card.Title>
                  <Card.Text className="text-muted mb-0">
                    Envio de mídias, offline e sincronização
                  </Card.Text>
                </div>
                <a href="#" className="text-decoration-none">
                  Ver tudo <FiExternalLink />
                </a>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Common topics */}

      {/* Contacts */}
      <Container style={{ maxWidth: 980 }} className="mt-5 mb-5">
        <SectionTitle
          title="Contatos de Suporte"
          subtitle="Fale com nossa equipe"
        />
        <Row className="g-3">
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <FiPhone /> <strong>Mara</strong>
                </div>
                <div className="mb-2">
                  <a
                    href="tel:+556384066672"
                    className="text-decoration-none d-block"
                  >
                    +55 63 8406-6672
                  </a>
                  <a
                    href="https://wa.me/556384066672"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none d-inline-flex align-items-center gap-2 mt-1"
                  >
                    <FiMessageCircle /> WhatsApp
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <FiPhone /> <strong>Marcelo</strong>
                </div>
                <div className="mb-2">
                  <a
                    href="tel:+556384066672"
                    className="text-decoration-none d-block"
                  >
                    +55 63 8406-6672
                  </a>
                  <a
                    href="https://wa.me/556384066672"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none d-inline-flex align-items-center gap-2 mt-1"
                  >
                    <FiMessageCircle /> WhatsApp
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <FiMail /> <strong>E-mail</strong>
                </div>
                <a
                  href="mailto:suporte@redesucodelaranja.com"
                  className="text-decoration-none"
                >
                  suporte@redesucodelaranja.com
                </a>
                <p className="text-muted mb-0 mt-2" style={{ fontSize: 14 }}>
                  Resposta em até 1 dia útil
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Footer */}
      <footer className="text-center text-muted py-4" style={{ fontSize: 14 }}>
        © {new Date().getFullYear()} VivaVoz • Central de Ajuda
      </footer>
    </div>
  );
};

export default SupportPage;
